import storage from '@woulsl/storage';
import session from '@woulsl/storage/session';

export const USER_TOKEN_KEY = '_U_TOKEN';

let currentTokenValue = null;

// 设置user token
export function setUserToken(token) {
  //
  if (!token) {
    //
    console.log('no token value');
    return;
  }
  //
  currentTokenValue = token;

  storage.set(USER_TOKEN_KEY, token);
}

// 获取user token
export function getUserToken() {
  //
  if (currentTokenValue) {
    return currentTokenValue;
  }
  //
  const token = storage.get(USER_TOKEN_KEY);
  //
  currentTokenValue = token;
  //
  return token;
}

//
export { session, storage };
// 改写，添加用户token
const defaults = (innerStorage) => {
  const methods = {};
  //
  ['get', 'set', 'remove'].forEach((method) => {
    methods[method] = function (...args) {
      const innerArgs = args;
      const key = args[0];
      const token = getUserToken() || '';
      //
      innerArgs[0] = [token, key].join('|');
      //
      return innerStorage[method].apply(null, innerArgs);
    };
  });

  //
  return {
    ...methods,
    clear: innerStorage.clear
  };
};
//
export default defaults(storage);
